import { Skeleton } from "@/components/skeletons/Skeleton";

export function FileCoverInputWithRecorderSkeleton() {
  return (
    <div className="flex h-48 gap-x-4">
      <Skeleton className="h-full w-2/3 rounded-2xl" />
      <Skeleton className="h-full w-1/3 rounded-2xl" />
    </div>
  );
}
